// src/components/Admin/ReportManager/ReportersModal.jsx
import { useState, forwardRef, useImperativeHandle } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Table, TableHead, TableRow, TableCell, TableBody,
  Button, Typography,
} from '@mui/material';
import api from '../../../api/axios';

const ReportersModal = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reporters, setReporters] = useState([]);

  /* 외부에서 open(type, id) 호출 */
  useImperativeHandle(ref, () => ({
    open(type, id) {
      setLoading(true);
      api.get(`/api/reports/reporters/?type=${type}&id=${id}`)
        .then((res) => {
          const list = res.data.reports || [];  // username, reason, created_at
          setReporters(list);
          setOpen(true);
        })
        .catch(() => alert('신고자 조회 실패'))
        .finally(() => setLoading(false));
    },
  }));

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="sm"
      sx={{
        '& .MuiDialog-paper': {
          /* 모바일: 90 % 축소 */
          '@media (max-width:600px)': {
            transform: 'scale(0.9)',
            transformOrigin: 'top left',
          },
        },
      }}
    >
      <DialogTitle>📋 신고자 목록</DialogTitle>

      <DialogContent>
        {loading ? (
          <Typography>불러오는 중...</Typography>
        ) : reporters.length === 0 ? (
          <Typography>신고자가 없습니다.</Typography>
        ) : (
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>신고자</TableCell>
                <TableCell>사유</TableCell>
                <TableCell>신고일</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reporters.map((r, idx) => (
                <TableRow key={idx}>
                  <TableCell>{r.username}</TableCell>
                  <TableCell>{r.reason}</TableCell>
                  <TableCell>{r.created_at}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpen(false)}>닫기</Button>
      </DialogActions>
    </Dialog>
  );
});

export default ReportersModal;
